import http from "@/http-common";
import Order, {OrderDTO, PaginatedOrders} from "@/api/Order";
import OrdersRequestInterface from "@/request/OrdersRequestInterface";
import PendingOrders, {PendingOrdersDTO} from "@/api/Order/PendingOrders";
import OrderCounts, {OrderCountsDTO} from "@/api/Order/OrderCounts";

class OrderService {
    async getPaginatedOrders(page: number, filter?: string): Promise<PaginatedOrders> {
        const queryParams: { [k: string]: string } = {};
        queryParams.page = page.toString();
        if (filter) {
            queryParams.filter = filter;
        }

        const url = '/customer/ajaxOrder/ordersSummary';
        const response = await http.get<OrdersRequestInterface>(url, {params: queryParams});
        const paginatedOrders = new PaginatedOrders();
        paginatedOrders.page = response.data.page;
        paginatedOrders.perPage = response.data.perPage;
        paginatedOrders.total = response.data.total;
        paginatedOrders.orders = response.data.orders.map(orderDTO => new Order(orderDTO));
        return paginatedOrders;
    }

    async getOrderById(orderId: number): Promise<Order> {
        const queryParams: { [k: string]: string } = {};
        queryParams.id = orderId.toString();
        const url = '/customer/ajaxOrder/orderInfo';
        const response = await http.get<OrderDTO>(url, {params: queryParams});
        return new Order(response.data);
    }

    async checkForPendingOrders(): Promise<PendingOrders> {
        const url = '/customer/ajaxOrder/checkForPendingOrders';
        const response = await http.get<PendingOrdersDTO>(url);
        return new PendingOrders(response.data);
    }

    async countOrders(): Promise<OrderCounts> {
        const url = '/customer/ajaxOrder/countOrders';
        const response = await http.get<OrderCountsDTO>(url);
        return new OrderCounts(response.data);
    }
}

export default new OrderService();